import { AdminAppState } from '../../state';
import { CreatePlaceInput } from '../../mutations';
import { getImage } from '../image';
import { getPlaceCategoryIds } from './get-place-category-ids';
import { getPlaceDescription } from './get-place-description';
import { getPlaceLocation } from './get-place-location';
import { getPlaceName } from './get-place-name';
import { getPlacePageId } from './get-place-page-id';
import { getPlacePosterImages } from './get-place-poster-images';
import { getPlaceTagsArray } from './get-place-tags-array';
import { identity } from 'lodash';

export const getCreatePlaceInput = (placeKey: string) => (
  state: AdminAppState,
): CreatePlaceInput => {
  const posterImages = getPlacePosterImages(placeKey)(state);

  const images = posterImages
    .map(({ imageKey, type }) => {
      const image = getImage(imageKey)(state);
      if (image.id) {
        return { imageId: image.id, type };
      } else {
        return null;
      }
    })
    .filter(identity) as CreatePlaceInput['images'];

  const location = getPlaceLocation(placeKey)(state);

  const { address = {} } = location;

  const {
    streetAddress = '',
    locality = '',
    region = '',
    postalCode = '',
  } = address;

  return {
    categoryIds: getPlaceCategoryIds(placeKey)(state),
    description: getPlaceDescription(placeKey)(state),
    images,
    locations: [
      {
        address: {
          streetAddress,
          locality,
          region,
          postalCode,
        },
      },
    ],
    name: getPlaceName(placeKey)(state),
    tags: getPlaceTagsArray(placeKey)(state),
    pageId: getPlacePageId(placeKey)(state),
  };
};
